/* MoRetro Studio - pont d'authentification Railway
   Charger APRES Firebase Auth et AVANT tous les fichiers mts-*.js. */
(function moretroAdminAuthBridge() {
  "use strict";

  if (window.__moretroAdminAuthInstalled) return;
  window.__moretroAdminAuthInstalled = true;

  var RAILWAY_ORIGIN = "https://bubbly-vibrancy-production.up.railway.app";
  var PROTECTED_PATHS = [
    "/api/shopify/orders",
    "/api/shopify/customers",
    "/api/shopify/update-customer",
    "/api/shopify/abandoned-checkouts",
    "/api/shopify/create-draft-order",
    "/api/shopify/send-quote",
    "/api/shopify/draft-order-status",
    "/api/shopify/quote-pdf",
    "/api/shopify/fulfill-order",
    "/api/quotes/send-for-approval",
    "/api/project/status",
    "/api/sendcloud/create-label",
    "/api/support"
  ];

  var nativeFetch = window.fetch.bind(window);
  var tokenPromise = null;

  function waitForFirebaseUser() {
    return new Promise(function (resolve) {
      var startedAt = Date.now();

      function connect() {
        if (window.firebase && typeof window.firebase.auth === "function") {
          var auth = window.firebase.auth();
          if (auth.currentUser) return resolve(auth.currentUser);

          var finished = false;
          var unsubscribe = function () {};
          var timer = setTimeout(function () {
            if (finished) return;
            finished = true;
            unsubscribe();
            resolve(null);
          }, 8000);

          unsubscribe = auth.onAuthStateChanged(function (user) {
            if (finished || !user) return;
            finished = true;
            clearTimeout(timer);
            unsubscribe();
            resolve(user);
          }, function () {
            if (finished) return;
            finished = true;
            clearTimeout(timer);
            unsubscribe();
            resolve(null);
          });
          return;
        }

        if (Date.now() - startedAt >= 8000) return resolve(null);
        setTimeout(connect, 100);
      }

      connect();
    });
  }

  async function adminToken(forceRefresh) {
    if (!tokenPromise || forceRefresh) {
      tokenPromise = waitForFirebaseUser().then(function (user) {
        if (!user || typeof user.getIdToken !== "function") return "";
        return user.getIdToken(Boolean(forceRefresh));
      }).catch(function () { return ""; });
    }
    return tokenPromise;
  }

  function protectedRailwayUrl(value) {
    try {
      var url = new URL(value, window.location.href);
      if (url.origin !== RAILWAY_ORIGIN) return false;
      return PROTECTED_PATHS.some(function (path) {
        return url.pathname === path || url.pathname.indexOf(path + "/") === 0;
      });
    } catch (_) {
      return false;
    }
  }

  window.fetch = async function moretroAuthenticatedFetch(input, init) {
    var requestInit = init ? Object.assign({}, init) : {};
    var requestUrl = typeof input === "string" ? input : input && input.url;

    if (!protectedRailwayUrl(requestUrl)) {
      return nativeFetch(input, requestInit);
    }

    var headers = new Headers(
      requestInit.headers || (typeof Request !== "undefined" && input instanceof Request ? input.headers : undefined)
    );
    var token = await adminToken(false);
    if (token) headers.set("Authorization", "Bearer " + token);
    requestInit.headers = headers;

    var response = await nativeFetch(input, requestInit);
    if (response.status !== 401 || !token) return response;

    var refreshedToken = await adminToken(true);
    if (!refreshedToken) return response;
    headers.set("Authorization", "Bearer " + refreshedToken);
    requestInit.headers = headers;
    return nativeFetch(input, requestInit);
  };
})();
